import { useSession } from '../api';

/** Rendered in the AppShell header, which sits on a dark background. */
export function SessionActions() {
  const { displayName, signOut } = useSession();

  if (!signOut) {
    return <span className="text-xs text-white/40">{displayName ?? 'Dev bypass'} · no sign-out</span>;
  }

  return (
    <div className="flex items-center gap-3">
      {displayName ? <span className="hidden text-xs text-white/60 sm:inline">{displayName}</span> : null}
      <button
        type="button"
        onClick={signOut}
        className="rounded-lg border border-white/20 px-3 py-1.5 text-xs font-medium text-white transition hover:bg-white/10"
      >
        Sign out
      </button>
    </div>
  );
}
